import api from '../api'
import { IPartner } from '../loadPartners'

export type ICreatePartnerForm = Pick<IPartner, 'name' | 'description' | 'email' | 'phone' | 'hostName'>

export function createPartner(partner: ICreatePartnerForm): Promise<void> {
    return api.post({ path: '/partners/', body: partner })
}
